import { FilePen } from 'lucide-react';
import { useState, type ReactElement } from 'react';

import { CardFrame } from '@/components/ui/card-frame';
import type { DossierPerson } from '@/features/document-dossier/types';
import { usePermission } from '@/hooks/usePermission';
import { useDocumentCompanyAccess } from '@/lib/document-company';
import type { DocumentStatus } from '@/lib/document-status';
import { useMe } from '@/lib/me';

import { RequestModal } from './RequestModal';

// "Solicitar modificación" desde la ficha (G3-1, D2; reunión 30:24): un vigente puede
// pedirse a modificar con el permiso de solicitar o siendo su dueño de proceso con lectura
// de documentos (el API aplica la misma regla). Solo bajo la empresa del documento.

export interface RequestChangeEntry {
  id: string;
  companyId: string;
  code: string;
  title: string | null;
  status: DocumentStatus;
  owner: DossierPerson | null;
}

export function RequestChangeCard({ entry }: { entry: RequestChangeEntry }): ReactElement | null {
  const canRequest = usePermission('quality:document:request');
  const canRead = usePermission('quality:master-list:read');
  const access = useDocumentCompanyAccess(entry.companyId);
  const me = useMe().data?.data.user_id ?? null;
  const [open, setOpen] = useState(false);
  const isOwner = me !== null && entry.owner?.userId === me && canRead;
  if (entry.status !== 'vigente' || access.kind !== 'active' || !(canRequest || isOwner)) {
    return null;
  }
  return (
    <CardFrame title="Modificación" className="d2">
      <div className="cb">
        <p className="fld-note">
          Si el documento necesita cambios, pide a Calidad su modificación con el motivo.
        </p>
        <button type="button" className="btn mut" onClick={() => setOpen(true)}>
          <FilePen size={16} aria-hidden="true" />
          Solicitar modificación
        </button>
      </div>
      {open && (
        <RequestModal
          mode={{
            kind: 'modificacion',
            target: { id: entry.id, code: entry.code, title: entry.title },
          }}
          onClose={() => setOpen(false)}
        />
      )}
    </CardFrame>
  );
}
